import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";


const CardAdsBannerFourImg = (props) => {

    const { isMobile } = useSelector(state => state.general);

    return (

        <a 
            target="_blank"
            href={props.data.url !== null && props.data.url !== "" ? props.data.url : '#'} 
            onClick={(e) => {if(e.currentTarget.getAttribute('href') === '#'){e.preventDefault();}}} 
            className="w-full block relative"  
            style={ 
                isMobile ?
                {width: 'calc(50% - 8px)', 'marginRight': `${props.index % 2 !== 0 ? '16px' : '0px'}`, marginTop: `${props.index > 1 ? '16px' : '0px'}`}
                :
                {width: 'calc(25% - 12px)', marginRight: `${props.index === 0 ? '0px' : '16px'}`, marginTop: '0px'}
                }
                >
            <div>
                <div className="h-full styles_Banner--a__tCKhr" style={{borderRadius: '16px', 'lineHeight': '0'}}>
                    <picture>
                        <LazyLoadImage 
                            className="w-full h-full styles_Banner__image__C8h94 inline-block" 
                            src={props.data.image} 
                            alt={props.data.alt} 
                            title={props.data.alt} 
                            style={{objectFit: 'cover', 'borderRadius': '16px'}} />
                    </picture>
                </div>
            </div>
        </a>

    );
}

export default CardAdsBannerFourImg;